import Header from "@/atomic/atoms/Header";
import OrgPayment from "@/atomic/organisms/orgPayment";
import { PropsView } from "./Models";
import useI18n from "@/hooks/useI18n";
import { useThemeContext } from "@/contexts/ThemeContext";

export default function CheckoutView({
  goToCard,
  goToPix,
  goBack,
}: PropsView) {
  const { t } = useI18n();
  const { themeName } = useThemeContext();
  const title = themeName === 'zapay' ? 'Pedágio' : t("pages:checkout:payment");

  return (
    <div className="h-full">
      <Header
        title={title}
        goBack={goBack}
        hasLeftButton
      />
      <main className="p-2 w-full flex justify-center text-black h-form bg-white">
        <article className="h-full flex flex-col justify-between w-[calc(480px)]">
          <div className="pb-4">
            <h2 className="text-2xl mt-4 font-semibold">{t("pages:checkout:paymentMethod")}</h2>
            <h3 className="text-sm mt-2">{t("pages:checkout:paymentMethodDescription")}</h3>
            <button type="submit" onClick={goToCard} className="w-full flex justify-between items-center mt-5 text-start">
              <div className="flex items-center">
                <div className="bg-gray-100 rounded-theme-large p-4">
                <img 
                  src={"/svg/icon-payment-card.svg"}
                    width={20}
                    height={14}
                    alt="Card credit icon"
                  />
                </div>
                <div className="ml-3">
                  <p className="text-base">{t("pages:checkout:creditCard")}</p>
                  <p className="text-xs">{t("pages:checkout:creditCardDescription")}</p>
                </div>
              </div>
              <img 
                src={"/svg/icon-arrow-right.svg"}
                width={10}
                height={10}
                alt={t("pages:checkout:selectCreditCardAlt")}
              />
            </button>
            <div className="w-full h-px bg-slate-300 mt-4 mb-4" />
            <button type="submit" onClick={goToPix} className="w-full flex justify-between items-center text-start">
              <div className="flex items-center">
                <div className="bg-gray-100 rounded-theme-medium p-4">
                <img 
                  src={"/svg/icon-payment-pix.svg"}
                  width={20}
                  height={20}
                  alt="pix icon"
                />
              </div>
                <div className="ml-3">
                  <p className="text-base">{t("pages:checkout:pix")}</p>
                  <p className="text-xs">{t("pages:checkout:pixDescription")}</p>
                </div>
              </div>
              <img 
                src={"/svg/icon-arrow-right.svg"}
                width={10}
                height={10}
                alt={t("pages:checkout:selectPixAlt")}
              />
            </button>
          </div>
          <OrgPayment 
            disabled
            textLabel={t("pages:checkout:singlePayment")}
          />
        </article>
      </main>
    </div>
  );
}
